import AirDatepicker from 'air-datepicker';

export const initDataTime = function() {
  const dataDateTimes = document.querySelectorAll('[data-datetime]')

  if (dataDateTimes.length > 0) {
    dataDateTimes.forEach((item) => {
      new AirDatepicker(item, {
        isMobile: true,
        autoClose: true
      })
    })
  }

  const dataDateTimesOnlyNow = document.querySelectorAll('[data-datetime-only-now]')

  if (dataDateTimesOnlyNow.length > 0) {
    dataDateTimesOnlyNow.forEach((item) => {
      new AirDatepicker(item, {
        isMobile: true,
        autoClose: true,
        minDate: new Date()
      })
    })
  }

  const dataDateTimesOnlyPrev = document.querySelectorAll('[data-datetime-only-prev]')

  if (dataDateTimesOnlyPrev.length > 0) {
    dataDateTimesOnlyPrev.forEach((item) => {
      new AirDatepicker(item, {
        isMobile: true,
        autoClose: true,
        maxDate: new Date()
      })
    })
  }

}
export const initDataTimeFancybox = function() {
  const dataDateTimes = document.querySelectorAll('[data-datetime-fancybox]')

  if (dataDateTimes.length > 0) {
    dataDateTimes.forEach((item) => {
      new AirDatepicker(item, {
        isMobile: true,
        autoClose: true
      })
    })
  }

}
